import { Alert, Button, List, ListItemButton, ListItemText, Stack, Typography } from '@mui/material'
import type { MemberRole } from '../api/generated/MemberRole'
import type { Position } from '../api/generated/Position'
import type { Shift } from '../api/generated/Shift'
import { useApi } from '../api/useApi'
import { FillRate } from '../shifts/FillRate'
import { fillOf } from '../shifts/fill'

export function PositionList({ slug, role }: { slug: string; role: MemberRole }) {
  const { data: positions, error } = useApi<Position[]>(`/events/${slug}/positions`)
  const { data: shifts } = useApi<Shift[]>(`/events/${slug}/shifts`)
  const shiftsOf = (id: string) => shifts?.filter((shift) => shift.position_id === id) ?? []
  const fillOfPosition = (id: string) => {
    const fill = fillOf(shiftsOf(id))
    return fill.required > 0 && <FillRate fill={fill} />
  }
  return (
    <Stack spacing={2}>
      {error && <Alert severity="error">{error}</Alert>}
      {positions?.length === 0 && <Typography color="text.secondary">Aucun poste.</Typography>}
      {positions && positions.length > 0 && (
        <List dense disablePadding>
          {positions.map((position) => (
            <ListItemButton
              key={position.id}
              component="a"
              href={`/events/${slug}/positions/${position.id}`}
            >
              <ListItemText primary={position.name} secondary={position.location || undefined} />
              {fillOfPosition(position.id)}
            </ListItemButton>
          ))}
        </List>
      )}
      {role === 'organizer' && (
        <Button
          variant="outlined"
          href={`/events/${slug}/positions/new`}
          sx={{ alignSelf: 'flex-start' }}
        >
          Ajouter un poste
        </Button>
      )}
    </Stack>
  )
}
